import * as actionTypes from "../constants/categoryConstants";

export const categoryReducers = (category = [], action) => {
  switch (action.type) {
    case actionTypes.GET_CATEGORIES:
      return action.payload;
    default:
      return category;
  }
};
